import { VendorType } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { get, has } from 'lodash';
import getResourceParamPrefix from 'new/components/settings/VendorBuilder/getResourceParamPrefix';
import { EndpointType } from 'new/components/settings/VendorBuilder/types';

const mapAuthType = {
  OAUTH2: 'oauth2',
  OAUTH1: 'oauth1a',
};

export default function parseVendorToVendorSpec(baseVendor: VendorType) {
  let { dynamicValues, ...restVendor } = baseVendor;
  // Cloning due to dynamic values;
  const vendor = JSON.parse(JSON.stringify(restVendor));
  Object.keys(dynamicValues).forEach((path) => {
    const keyValueJson = dynamicValues[path];
    Object.keys(keyValueJson).forEach((key) => {
      const vendorEntry = get(vendor, path);
      vendorEntry[key] = keyValueJson[key];
    });
  });
  const { auth_templates: templates, endpoints, config, ...rest } = vendor;

  const auth_templates = templates.map((template) => ({
    ...template,
    name: vendor.name + '.' + template.name,
  }));

  if (auth_templates.some((template) => template.config['auth.type']?.includes?.('OAUTH'))) {
    let authType = auth_templates.reduce(
      (acc, template) => {
        let thisAuthType;

        switch (template.config['auth.type']) {
          case 'OAUTH1': {
            if (
              has(template.config, 'oauth1.token_exchange_type') &&
              template.config['oauth1.token_exchange_type'] === '3-legged'
            ) {
              thisAuthType = mapAuthType[template.config['auth.type']];
            }
            break;
          }
          case 'OAUTH2': {
            if (
              has(template.config, 'oauth2.token_exchange_type') &&
              template.config['oauth2.token_exchange_type'] === '3-legged'
            ) {
              thisAuthType = mapAuthType[template.config['auth.type']];
            }
            break;
          }
          default:
            break;
        }

        if (auth_templates.length === 1) {
          acc = thisAuthType;
        } else {
          acc[template.name] = mapAuthType[template.config['auth.type']];
        }
        return acc;
      },
      auth_templates.length === 1 ? '' : {},
    );

    config.authType = authType;
  } else {
    //remove authType object if there are no 3-legged oauth params
    delete config['authType'];
  }

  const postVendor = {
    config,
    ...rest,
    auth_templates,
  };

  const [postEndpoints, postParameters] = (endpoints as EndpointType[]).reduce(
    (result, endpoint, index) => {
      const { parameters, ...rest } = endpoint;
      rest.name = vendor.name + '.' + rest.name;
      rest.vendor_name = vendor.name;
      result[0][rest.name] = rest;
      result[1]['for: ' + rest.name] = parameters.map((param) => ({
        ...param,
        name: getResourceParamPrefix(vendor, index) + (param.name || ''),
        resource_type: !!endpoint.sink_template ? 'SINK' : 'SOURCE',
        vendor_endpoint_name: rest.name,
      }));
      return result;
    },
    [{}, {}],
  );

  return JSON.stringify(
    {
      [vendor.name]: {
        'POST /vendors': postVendor,
        'POST /vendor_endpoints': postEndpoints,
        'POST /resource_parameters': postParameters,
      },
    },
    null,
    2,
  );
}
